import React, { type FC } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  FormElement,
  IconFATrashCanRaw,
  LINK_VARIANT_EXTRALIGHT,
  Link,
  Select,
} from 'mailup-web-components'

import type { ColumnName } from 'Pages/RecipientsList/model'

import useColumnNameOptions from 'Pages/RecipientsList/hooks/useColumnNameOptions'

import {
  modalConfigColumnsChangeColumnCallback,
  modalConfigColumnsRemoveColumnCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modals'
import { modalColumnsState } from 'Pages/RecipientsList/recoil/state/modals'

interface ColumnItemProps {
  index: number
  canDelete: boolean
}

const ColumnItem: FC<ColumnItemProps> = ({ index, canDelete }) => {
  const intl = useIntl()

  const { items } = useRecoilValue(modalColumnsState)

  const changeColumn = useRecoilCallback(
    modalConfigColumnsChangeColumnCallback,
    [],
  )

  const removeColumn = useRecoilCallback(
    modalConfigColumnsRemoveColumnCallback,
    [],
  )

  const options = useColumnNameOptions(index)

  const handleChange = (v: ColumnName): void => {
    void changeColumn(index, v)
  }

  const handleRemove = (): void => {
    void removeColumn(index)
  }

  return (
    <Flex gap="16px">
      <FlexItem flexGrow={1} minWidth="0px">
        <FormElement>
          <Select
            searchable
            value={items[index]}
            onChange={handleChange}
            options={options}
            data-mu-test={`config-column-item config-column-item-${index}`}
            placeholder={intl.formatMessage({
              id: 'Load.RecipientsList.SelectColumnPlaceholder',
            })}
          />
        </FormElement>
      </FlexItem>
      <Flex
        flexBasis="16px"
        alignItem="center"
        justifyContent="center"
        height="36px"
      >
        <Link
          variant={LINK_VARIANT_EXTRALIGHT}
          disabled={!canDelete}
          alignContent
          data-mu-test="remove-column"
          onClick={handleRemove}
        >
          <IconFATrashCanRaw width="14px" />
        </Link>
      </Flex>
    </Flex>
  )
}

export default ColumnItem
